export default {
  namespaced: true,
  state: {
    powerInfoMsg: {},
    powerSupplyVoltageArray: [0, 0, 0],
    calBrightness: 0,
    maxCalBrightness: 0,
    powerState: 0,
    pixels: 0,
    leds: 0,
    ileds: 0,
    eleds: 0,
    current: 0,
    maxCurrent: 24,
  },
  getters: {
    getPower1Voltage: (state) => {
      return state.powerSupplyVoltageArray[0];
    },
    getPower2Voltage: (state) => {
      return state.powerSupplyVoltageArray[1];
    },
    getPowerRefVoltage: (state) => {
      return state.powerSupplyVoltageArray[2];
    },
    getCalBrightness: (state) => {
      return state.calBrightness;
    },
    getMaxCalBrightness: (state) => {
      return state.maxCalBrightness;
    },
    getPixels: (state) => {
      return state.pixels;
    },
    getLeds: (state) => {
      return state.leds;
    },
    getiLeds: (state) => {
      return state.ileds;
    },
    geteLeds: (state) => {
      return state.eleds;
    },
    getCurrent: (state) => {
      return state.current;
    },
    getMaxCurrent: (state) => {
      return state.maxCurrent;
    },
    getProtectionStatus: (state) => {
      let protectionStatus;
      if (state.powerState == 0) {
        protectionStatus = "OK";
      } else {
        protectionStatus = "OVERLOAD";
      }
      return protectionStatus;
    },
    getProtectionColor: (state) => {
      let protectionColor;
      if (state.powerState == 0) {
        protectionColor = "gray";
      } else {
        protectionColor = "red";
      }
      return protectionColor;
    },
  },
  mutations: {
    setPowerInfoMsg: (state, val) => {
      let parameterMask = 0;
      state.powerInfoMsg = val;
      if (
        Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "powervoltage")
      ) {
        parameterMask |= 1;
        for (let i = 0; i < state.powerInfoMsg.powervoltage.length; i++) {
          state.powerSupplyVoltageArray[i] = state.powerInfoMsg.powervoltage[i];
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(
          state.powerInfoMsg,
          "calbrightness"
        )
      ) {
        parameterMask |= 2;
        state.calBrightness = parseInt(state.powerInfoMsg.calbrightness);
      }
      if (
        Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "powerstate")
      ) {
        parameterMask |= 4;
        state.powerState = parseInt(state.powerInfoMsg.powerstate);
      }
      if (Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "pixels")) {
        parameterMask |= 8;
        state.pixels = parseInt(state.powerInfoMsg.pixels);
      }
      if (Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "leds")) {
        parameterMask |= 0x10;
        state.leds = parseInt(state.powerInfoMsg.leds);
      }
      if (Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "ileds")) {
        parameterMask |= 0x20;
        state.ileds = parseInt(state.powerInfoMsg.ileds);
      }
      if (
        Object.prototype.hasOwnProperty.call(state.powerInfoMsg, "maxcurrent")
      ) {
        parameterMask |= 0x40;
        state.maxCurrent = parseInt(state.powerInfoMsg.maxcurrent);
      }
      /* Post processing */
      if (0x7f == parameterMask) {
        let adjustBrightness = false;
        if (state.ileds > state.leds) {
          state.ileds = state.leds;
        }
        state.eleds = state.leds - state.ileds;
        /* -- */
        if (0 >= state.calBrightness || state.calBrightness > 100) {
          state.calBrightness = 100;
          adjustBrightness = true;
        }
        /* Calculate current from brightness */
        let ledCurrent = state.ileds * 0.02;
        let current = Math.round((ledCurrent * state.calBrightness) / 100);
        if (state.maxCurrent < current) {
          current = state.maxCurrent;
        }
        state.current = current;
        state.maxCalBrightness = Math.round(
          (100 * state.maxCurrent) / ledCurrent
        );
        /* Adjust brightness */
        if (adjustBrightness) {
          let brightness = Math.round((100 * current) / ledCurrent);
          if (brightness > state.maxCalBrightness) {
            brightness = state.maxCalBrightness;
          }
          state.calBrightness = brightness;
        }
      }
    },
    setCurrent: (state, val) => {
      state.current = val;
    },
    setCalBrightness: (state, val) => {
      state.calBrightness = val;
    },
    setMaxCurrent: (state, val) => {
      state.maxCurrent = val;
    },
    setMaxCalBrightness: (state, val) => {
      state.maxCalBrightness = val;
    },
    setiLeds: (state, val) => {
      state.ileds = val;
    },
    seteLeds: (state, val) => {
      state.eleds = val;
    },
  },

  actions: {},
};
